import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import googleSignin from "./assets/img/btn_google_signin.png";
import mainLogo from "./assets/img/emersonLogo.jpg";
import AuthContext from "./auth-context";
import history from "./history";

const GoogleLoginForm = () => {
  const authStore = useContext(AuthContext);
  const isAuthenticated = authStore.isAuthenticated();

  const login = useGoogleLogin({
    onSuccess: tokenResponse => {
      authStore
        .authenticate(tokenResponse.access_token)
        .then(() => {
          history.push("/m1/dashboard");
        })
        .catch(() => {
          history.push("/login");
        });
    }
  });

  return (
    <div style={{ width: 382, margin: "100px auto" }}>
      <div style={{ margin: "20px", textAlign: "center" }}>
        <img src={mainLogo} alt="" style={{ width: "30rem" }} />
      </div>
      {!isAuthenticated && (
        <button
          onClick={() => login()}
          style={{
            border: "none",
            background: "none",
            padding: 0,
            margin: 0,
            textAlign: "center"
          }}
        >
          <img src={googleSignin} alt="" />
        </button>
      )}
      {isAuthenticated && <Link to="/m1/dashboard">Go to Dashboard</Link>}
    </div>
  );
};

const LoginForm = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={clientId} pluginName="testing_react_us_app">
      <GoogleLoginForm />
    </GoogleOAuthProvider>
  );
};

export default LoginForm;
